var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
import { EventEmitter } from 'events';
import config from '../services/config';
import { store } from '../store/store';
var instance = null;
var NodeServer = /** @class */function (_super) {
  __extends(NodeServer, _super);
  function NodeServer() {
    var _this = _super.call(this) || this;
    _this.handleDisconnect = _this.handleDisconnect.bind(_this);
    _this.connectToNode = _this.connectToNode.bind(_this);
    _this.addConnectionListener = _this.addConnectionListener.bind(_this);
    _this.handleConnect = _this.handleConnect.bind(_this);
    _this.handleError = _this.handleError.bind(_this);
    return _this;
  }
  // Singleton instance getter
  NodeServer.get = function () {
    if (instance == null) {
      instance = new this();
      instance.init();
    }
    return instance;
  };
  // Initialize the line monitor
  NodeServer.prototype.init = function () {
    var _this = this;
    this.isConnected = false;
    this.connectAttempts = 0;
    this.connectionListeners = [];
    this.socket = null;
    setTimeout(function () {
      _this.connectToNode();
    }, 500);
    return this;
  };
  // Handle a disconnection from the node server
  NodeServer.prototype.handleDisconnect = function () {
    console.log('NodeServer: Connection to server failed or disconnected. Attempting reconnect');
    for (var _i = 0, _a = this.connectionListeners; _i < _a.length; _i++) {
      var callback = _a[_i];
      callback(false, this.connectAttempts);
    }
    this.isConnected = false;
  };
  // Attempt to connect to the node server
  NodeServer.prototype.connectToNode = function () {
    var _this = this;
    var _a, _b;
    console.log('NodeServer: connecting');
    if (config.nodeServer == null) {
      console.log('NodeServer: disabled');
      return this;
    }
    if (this.socket) {
      console.log('NodeServer: socket exists');
      return this;
    }
    var callback;
    this.connectAttempts++;
    console.log("NodeServer: Connecting to server ".concat(config.nodeServer, " (").concat(this.connectAttempts, ")"));
    var appState = store.getState();
    if (((_b = (_a = appState.common) === null || _a === void 0 ? void 0 : _a.facility) === null || _b === void 0 ? void 0 : _b.id) == null) {
      console.log('NodeServer: awaiting facility data');
      return this;
    }
    this.socket = window.io.connect(config.nodeServer, {
      timeout: 6000,
      query: {
        'X-Facility-ID': appState.common.facility.id
      }
    });
    this.socket.on('error', function (err) {
      console.log("NodeServer: Socket.IO error: ".concat(err));
      if (!_this.isConnected) {
        _this.handleDisconnect();
      }
    });
    this.socket.on('connect', function () {
      console.log('NodeServer: Connected to server');
      for (var _i = 0, _a = _this.connectionListeners; _i < _a.length; _i++) {
        callback = _a[_i];
        callback(true, _this.socket);
      }
      _this.isConnected = true;
      _this.connectAttempts = 0;
    });
    this.socket.on('connect_failed', this.handleDisconnect);
    this.socket.on('reconnect_failed', this.handleDisconnect);
    this.socket.on('reconnecting', function () {
      console.log('NodeServer: Connection to server dropped. Automatic reconnection attempt');
      for (var _i = 0, _a = _this.connectionListeners; _i < _a.length; _i++) {
        callback = _a[_i];
        callback(false, _this.socket);
      }
      _this.connectAttempts++;
      _this.isConnected = false;
    });
    this.socket.on('station-status.change', function (data) {
      return _this.emit('station-status.change', data);
    });
    this.socket.on('station-status.list', function (data) {
      return _this.emit('station-status.list', data);
    });
    // Relay all events to the store
    var originalOnevent = this.socket.onevent;
    this.socket.onevent = function (packet) {
      store.dispatch({
        type: "NODE_SERVER/".concat(packet.data[0].toUpperCase()),
        data: packet.data.length > 1 ? packet.data[1] : null
      });
      // Relay the original event
      originalOnevent.call(_this.socket, packet);
    };
    if (appState.auth.loggedIn) {
      this.authenticate(appState.auth.token);
    }
    return this.socket;
  };
  // Add a listener for connection status changes
  NodeServer.prototype.addConnectionListener = function (callback) {
    if (this.isConnected) {
      callback(true, this.socket);
    }
    this.connectionListeners.push(callback);
    return this;
  };
  // Remove a listener for connection status changes
  NodeServer.prototype.removeConnectionListener = function (callback) {
    this.connectionListeners.splice(this.connectionListeners.indexOf(callback), 1);
    return this;
  };
  // Handle the socket connection
  NodeServer.prototype.handleConnect = function (data) {
    return this;
  };
  // Handle the socket error
  NodeServer.prototype.handleError = function () {
    return this;
  };
  NodeServer.prototype.authenticate = function (accessToken) {
    if (!this.socket) {
      this.connectToNode();
    } else {
      this.socket.emit('authenticate', "Bearer ".concat(accessToken.accessToken));
    }
  };
  NodeServer.prototype.disconnect = function () {
    if (this.socket) {
      this.socket.emit('unauthenticate');
    }
  };
  return NodeServer;
}(EventEmitter);
export default NodeServer;